export const UseDiscountCode = (api, voucher, custId) => {
    return api.get(`/api/v1/Discount/useDiscountCode?voucher=${voucher}&custId=${custId}`)
}